
import '../scss/main.scss';

import '../../node_modules/@fortawesome/fontawesome-pro/css/fontawesome.css';
import '../../node_modules/@fortawesome/fontawesome-pro/css/light.css';
import '../../node_modules/@fortawesome/fontawesome-pro/css/regular.css';
import '../../node_modules/@fortawesome/fontawesome-pro/css/solid.css';
import '../../node_modules/@fortawesome/fontawesome-pro/css/brands.css';

import { appConfig } from './app.config';

console.log(JSON.stringify(ENVIRONMENT));
console.log(JSON.stringify(appConfig));

if(!ENVIRONMENT.production) {
     const header = document.getElementsByTagName('head')[0];
     const meta = document.createElement('meta');
     meta.name = 'robots';
     meta.content = 'noindex, nofollow';
    header.appendChild(meta);
}

import { h, render } from 'preact';

import TxrHeader from './components/txr-header.js';
Array.from(document.getElementsByTagName('txr-header')).forEach((el) => {
    render(<TxrHeader/>, el);
});

import TxrFooter from './components/txr-footer.js';
Array.from(document.getElementsByTagName('TxrFooter')).forEach((el) => {
    render(<TxrFooter/>, el);
});

import TxrBottomDemo from './components/txr-bottom-demo.js';
Array.from(document.getElementsByTagName('TxrBottomDemo')).forEach((el) => {
    render(<TxrBottomDemo/>, el);
});

import TxrBottomGetStarted from './components/txr-bottom-get-started.js';
Array.from(document.getElementsByTagName('TxrBottomGetStarted')).forEach((el) => {
    render(<TxrBottomGetStarted/>, el);
});


import TxrBottomCaseStudy from './components/txr-bottom-case-study.js';
Array.from(document.getElementsByTagName('TxrBottomCaseStudy')).forEach((el) => {
    render(<TxrBottomCaseStudy/>, el);
});

import TxrPlanPanels from './components/txr-plan-panels';
Array.from(document.getElementsByTagName('TxrPlanPanels')).forEach((el) => {
    render(<TxrPlanPanels/>, el);
});

import TxrPlanCompare from './components/txr-plan-compare';
Array.from(document.getElementsByTagName('TxrPlanCompare')).forEach((el) => {
    render(<TxrPlanCompare/>, el);
});

import TxrPricingFaqItems from './components/txr-pricing-faq-items';
Array.from(document.getElementsByTagName('TxrPricingFaqItems')).forEach((el) => {
    render(<TxrPricingFaqItems/>, el);
});

import TxrTextUsForm from './components/txr-text-us-form';
Array.from(document.getElementsByTagName('TxrTextUsForm')).forEach((el) => {
    render(<TxrTextUsForm/>, el);
});

import TxrContactUsHsForm from './components/txr-contact-us-hs-form';
Array.from(document.getElementsByTagName('TxrContactUsHsForm')).forEach((el) => {
    render(<TxrContactUsHsForm/>, el);
});

import TxrPartnerForm from './components/txr-partner-form';
Array.from(document.getElementsByTagName('TxrPartnerForm')).forEach((el) => {
    render(<TxrPartnerForm/>, el);
});


import TxrPopupVideo from './components/txr-popup-video';
Array.from(document.getElementsByTagName('TxrPopupVideo')).forEach((el) => {
    render(<TxrPopupVideo src={el.attributes.src.nodeValue} content={el.attributes.content.nodeValue} triggerIds={el.attributes.triggerIds.nodeValue} />, el,);
});
import TxrCheckNumberForm from './components/txr-check-numer-form';

Array.from(document.getElementsByTagName('TxrCheckNumberForm')).forEach((el) => {
    render(<TxrCheckNumberForm/>, el);
});


import TxrScrollHelper from './components/txr-scroll-helper';
Array.from(document.getElementsByTagName('TxrScrollHelper')).forEach((el) => {
    render(<TxrScrollHelper offsetY={el.attributes.offsetY.nodeValue} offsetYmax={el.attributes.offsetYmax.nodeValue} scrollClass={el.attributes.scrollClass.nodeValue} elementIds={el.attributes.elementIds.nodeValue} />, el,);
});
/*
import TxrDropdownHover from './components/txr-dropdown-hover'
Array.from(document.getElementsByTagName('TxrDropdownHover')).forEach((el) => {
    render(<TxrDropdownHover header={el.attributes.header.nodeValue} label={el.attributes.label.nodeValue} />, el,);
});
*/

import TxrResourcesHub from './components/txr-resources-hub';
Array.from(document.getElementsByTagName('TxrResourcesHub')).forEach((el) => {
    render(<TxrResourcesHub/>, el);
});

import TxrNewsOverview from './components/txr-news-overview';
Array.from(document.getElementsByTagName('TxrNewsOverview')).forEach((el) => {
    render(<TxrNewsOverview/>, el);
});

import TxrPurchaseWorkflow from './components/txr-purchase-workflow';
Array.from(document.getElementsByTagName('TxrPurchaseWorkflow')).forEach((el) => {
    render(<TxrPurchaseWorkflow/>, el);
});

import TxrTrialWorkflow from './components/txr-trial-workflow';
Array.from(document.getElementsByTagName('TxrTrialWorkflow')).forEach((el) => {
    render(<TxrTrialWorkflow/>, el);
});

import TxrGatedContentForm from './components/txr-gated-content-form';
Array.from(document.getElementsByTagName('TxrGatedContentForm')).forEach((el) => {
    render(<TxrGatedContentForm/>, el);
});
/*
import TxrTopBanner from './components/txr-top-banner';
Array.from(document.getElementsByTagName('TxrTopBanner')).forEach((el) => {
    render(<TxrTopBanner/>, el);
});
*/

import TxrTopDiscountBanner from './components/txr-top-discount-banner';
Array.from(document.getElementsByTagName('TxrTopDiscountBanner')).forEach((el) => {
    render(<TxrTopDiscountBanner/>, el);
});

import TxrWebinarGatedContentForm from './components/txr-webinar-gated-content-form';
Array.from(document.getElementsByTagName('TxrWebinarGatedContentForm')).forEach((el) => {
    render(<TxrWebinarGatedContentForm/>, el);
});

import TxrExpandItem from './components/txr-expand-item';
Array.from(document.getElementsByTagName('TxrExpandItem')).forEach((el) => {
    render(<TxrExpandItem header={el.attributes.header.nodeValue} content={el.attributes.content.nodeValue} />, el,);
});

import TxrSubscribeNewsletterForm from './components/txr-subscribe-newsletter-form';
Array.from(document.getElementsByTagName('TxrSubscribeNewsletterForm')).forEach((el) => {
    render(<TxrSubscribeNewsletterForm successMessage={el.attributes.successMessage.nodeValue}/>, el);
});

import TxrRequestTrialHsForm from './components/txr-request-trial-hs-form.js';
Array.from(document.getElementsByTagName('TxrRequestTrialHsForm')).forEach((el) => {
    render(<TxrRequestTrialHsForm/>, el);
});


//----- Calendly hook
function isCalendlyEvent(e) {
    return e.origin === "https://calendly.com" && e.data.event && e.data.event.indexOf("calendly.") === 0;
};

window.addEventListener("message", function(e) {
   if(isCalendlyEvent(e)) {
        if(e.data.event === 'calendly.event_scheduled') {
            window.lintrk('track', { conversion_id: 9948713 });
        }
   }
});

window.addEventListener('load', (event) => {
    const urlParams = new URLSearchParams(window.location.search);
    const referralPartnerId = Number.parseInt(urlParams.get('pid'));
    if(referralPartnerId && Number.isInteger(referralPartnerId)) {
        const info =  {
            referralPartnerId: referralPartnerId,
            date: new Date()
        };
        localStorage.setItem(appConfig.referralPartnerIdKey, JSON.stringify(info));
    }

    //twilio lead
    const utm_source = urlParams.get('utm_source');
    const utm_medium = urlParams.get('utm_medium');
    if(utm_source === 'twilio' && utm_medium === 'marketplace') {
        const info =  {
            referralPartnerId: 20, //Twilio Marketplace for PROD
            date: new Date()
        };
        localStorage.setItem(appConfig.referralPartnerIdKey, JSON.stringify(info));
    }
  });